import { GroupResume } from 'domain/models';
import noDataBg from 'presentation/app/assets/images/no-task.png';
import ApexChart from 'react-apexcharts';

interface IProps {
  data?: GroupResume[];
}

export const StudentsByGroupChart = ({ data }: IProps) => {
  if (!data || data?.length === 0) {
    return (
      <div className="text-center">
        <img src={noDataBg} alt="Sem dados" height={100} width={100} />
      </div>
    );
  }

  const chartOptions = {
    chart: {
      stacked: true,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
      },
    },
  };

  const studentsByGroupData = data
    // .filter((item) => Number(item.students) > 0)
    .map((item) => {
      return {
        x: item.group,
        y: item.students,
      };
    });

  const chartSeries = [
    {
      name: 'Estudantes por grupo',
      data: studentsByGroupData,
    },
  ];

  // Add more pixels to the chart's height in order to let each bar fit correctly and be clearly visible
  const surplusHeight =
    studentsByGroupData.length > 10
      ? (studentsByGroupData.length - 10) * 30
      : 0;

  return (
    <ApexChart
      type="bar"
      options={chartOptions}
      height={400 + surplusHeight}
      series={chartSeries}
    />
  );
};
